import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import { useFanPublicationStore } from "%/stores/fan-publication-store";
import { useGeneralStore } from "%/stores/general-store";
import SmartFeedEngine from "~/smart-feed/smart-feed-engine";

export const useVotedStoryFeedStore = defineSmartFeedPiniaStore("voted-story-feed-store", {
  state: () => ({
    smartFeedEngine: new SmartFeedEngine(),
    metadata: {
      lastId: 0,
      publicationId: useFanPublicationStore().publicationId,
      userId: useGeneralStore().userId,
    },
  }),
  getters: {
    feedUrl() {
      return `publication/${this.metadata.publicationId}/stories/voted/smart-feed`;
    },
    smartFeedRequestGetParams() {
      return {
        last_id: this.metadata.lastId,
        user_id: this.metadata.userId,
      };
    },
  },
});
